import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'FirstCapital',
  standalone: true
})
export class FirstCapitalPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(0, 0);
  }
}
